import * as types from './types';

const initialState = {
  assets: [],
  isFetchingAssets: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_ASSETS:
    case types.SET_IS_FETCHING_ASSETS:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
